import { Box, Typography } from "@mui/material"

export default function ThanksPage() {
  return (
    <Box mt="20vh">
      <Typography variant="h4" sx={{ textAlign: "center", mb: "1em" }}>
        送信完了。
      </Typography>
      <Typography variant="h4" sx={{ textAlign: "center" }}>
        お問い合わせありがとうございました。
      </Typography>
    </Box>
  )
}
